import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock } from '../lib/icons';
import ContentSlot from './ContentSlot';

const Contact = () => {

  return (
    <section id="contact" className="py-20 bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[#E0E0E0] mb-4">
            <ContentSlot slotId="contact-heading" fallback="Get Your Console Fixed Today" contentType="heading" pageSection="contact" label="Section Heading" />
          </h2>
          <ContentSlot
            slotId="contact-subtitle"
            fallback="Ready for same-day service? Contact us now for a free quote and fast repair."
            contentType="paragraph"
            as="p"
            pageSection="contact"
            label="Section Subtitle"
            className="text-xl text-[#B0B0B0] max-w-3xl mx-auto"
          />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Contact Info */}
          <div className="space-y-8 lg:col-span-2">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="bg-gray-900 rounded-2xl p-8 shadow-lg border border-gray-800">
              <h3 className="text-2xl font-bold text-[#E0E0E0] mb-6">
                <ContentSlot slotId="contact-sd-heading" fallback="San Diego Location" contentType="subheading" pageSection="contact" label="San Diego Heading" />
              </h3>

              <div className="space-y-4 text-[#E0E0E0]">
                <div className="flex items-center space-x-4">
                  <div className="bg-[#00BFFF]/20 p-3 rounded-lg">
                    <Phone className="h-6 w-6 text-[#00BFFF]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">James</h4>
                    <a href="tel:+17602147244" className="text-[#FF1744] hover:text-[#39FF14]">
                      (760) 214-7244
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#FF1744]/20 p-3 rounded-lg">
                    <Mail className="h-6 w-6 text-[#FF1744]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Email</h4>
                    <a href="mailto:info@gamefixsolutions.com" className="text-[#FF1744] hover:text-[#39FF14]">
                      info@gamefixsolutions.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#39FF14]/20 p-3 rounded-lg">
                    <MapPin className="h-6 w-6 text-[#39FF14]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Address</h4>
                    <p className="text-[#39FF14]">5375 Napa St, San Diego, CA 92110</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#B0B0B0]/20 p-3 rounded-lg">
                    <Clock className="h-6 w-6 text-[#B0B0B0]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Hours</h4>
                    <p className="text-[#B0B0B0]">Mon-Sun: 9AM-9PM</p>
                  </div>
                </div>

                <div className="pt-4 space-y-3">
                  <Link
                    to="/book-repair"
                    className="w-full inline-flex items-center justify-center bg-[#39FF14] hover:bg-[#00BFFF] text-[#0D0D0D] px-6 py-3 rounded-lg font-bold transition-colors duration-200"
                  >
                    Book Appointment
                  </Link>
                  <a
                    href="https://share.google/jl29LJcRnhhdAP3Dm"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full inline-flex items-center justify-center bg-[#00BFFF] text-[#0D0D0D] px-6 py-3 rounded-lg font-semibold hover:bg-[#39FF14] transition-colors duration-200"
                  >
                    <MapPin className="h-5 w-5 mr-2" />
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-gray-900 rounded-2xl p-8 shadow-lg border border-gray-800">
              <h3 className="text-2xl font-bold text-[#E0E0E0] mb-6">
                <ContentSlot slotId="contact-temecula-heading" fallback="Temecula Location" contentType="subheading" pageSection="contact" label="Temecula Heading" />
              </h3>

              <div className="space-y-4 text-[#E0E0E0]">
                <div className="flex items-center space-x-4">
                  <div className="bg-[#00BFFF]/20 p-3 rounded-lg">
                    <Phone className="h-6 w-6 text-[#00BFFF]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Spencer</h4>
                    <a href="tel:+19512168534" className="text-[#FF1744] hover:text-[#39FF14]">
                      (951) 216-8534
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#FF1744]/20 p-3 rounded-lg">
                    <Mail className="h-6 w-6 text-[#FF1744]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Email</h4>
                    <a href="mailto:info@gamefixsolutions.com" className="text-[#FF1744] hover:text-[#39FF14]">
                      info@gamefixsolutions.com
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#39FF14]/20 p-3 rounded-lg">
                    <MapPin className="h-6 w-6 text-[#39FF14]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Service Area</h4>
                    <p className="text-[#39FF14]">Mobile service & pickup in Temecula Valley and surrounding areas</p>
                  </div>
                </div>

                <div className="flex items-center space-x-4">
                  <div className="bg-[#B0B0B0]/20 p-3 rounded-lg">
                    <Clock className="h-6 w-6 text-[#B0B0B0]" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#E0E0E0]">Hours</h4>
                    <p className="text-[#B0B0B0]">Mon-Sun: 9AM-9PM</p>
                  </div>
                </div>

                <div className="pt-4">
                  <a
                    href="https://www.google.com/maps/place/Temecula,+CA"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full inline-flex items-center justify-center bg-[#00BFFF] text-[#0D0D0D] px-6 py-3 rounded-lg font-semibold hover:bg-[#39FF14] transition-colors duration-200"
                  >
                    <MapPin className="h-5 w-5 mr-2" />
                    View on Google Maps
                  </a>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;